export function GetServiceBaseUrl(url) {
  return url.split('rest/services/')[0];
}

export function SetServiceToken(url, token) {
  let baseUrl = GetServiceBaseUrl(url);
  localStorage['agstoken_' + baseUrl] = token;
}

export function GetServiceToken(url) {
  let baseUrl = GetServiceBaseUrl(url);
  return localStorage['agstoken_' + baseUrl] || null;
}

export function GetAuthorizationsList() {
  let list = [];
  for (let key of Object.keys(localStorage)) {
    if (key.startsWith('agstoken_')) {
      let serviceUrl = key.replace('agstoken_', '');
      let token = localStorage[key];
      let name = serviceUrl.split('/rest/services/')[0];
      name = name.replace('https://', '').replace('http://', '');
      if (name.endsWith('/')) {
        name = name.slice(0, -1);
      }
      list.push({ serviceUrl, token, name });
    }
  }
  return list;
}

export function SignOutService(url) {
  let baseUrl = GetServiceBaseUrl(url);
  localStorage.removeItem('agstoken_' + baseUrl);
}